import * as React from 'react';

export default (props) => {
  let strokeColor;

  if (props.color) {
    strokeColor = props.color;
  } else {
    switch (props.state) {
      case 'hover':
        strokeColor = '#0A132B';
        break;
      case 'static':
        strokeColor = '#6C7280';
        break;
      case 'active':
        strokeColor = '#0067F4';
        break;
      default:
        strokeColor = '#B5BFD2';
    }
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      fill="none"
    >
      <rect width="18" height="16" x="3.5" y="4" stroke={strokeColor} strokeWidth="2" rx="2" />
      <path stroke={strokeColor} strokeLinecap="round" strokeWidth="2" d="M12.5 4v16M3.5 12h18" />
    </svg>
  );
};
